module.exports = __webpack_public_path__ + "static/media/des_rev_2.8180daf6.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/food/des_rev_2.pdf
// module id = 81
// module chunks = 0